// Simple console logging utility for development

import { config } from '@/config/env';

interface Logger {
  info: (message: string, data?: unknown) => void;
  success: (message: string, data?: unknown) => void;
  warning: (message: string, data?: unknown) => void;
  error: (message: string, data?: unknown) => void;
  debug: (message: string, data?: unknown) => void;
}

const isDevelopment = config.env === 'development';

// Create logger for a component
export function createLogger(componentName: string): Logger {
  const log = (message: string, data?: unknown) => {
    if (!isDevelopment) return; // Only log in development

    const timestamp = new Date().toLocaleTimeString();
    const prefix = `[${timestamp}] ${componentName}:`;

    if (data !== undefined) {
      // eslint-disable-next-line no-console
      console.log(`${prefix} ${message}`, data);
    } else {
      // eslint-disable-next-line no-console
      console.log(`${prefix} ${message}`);
    }
  };

  return {
    info: (message: string, data?: unknown) => log(message, data),
    success: (message: string, data?: unknown) => log(message, data),
    warning: (message: string, data?: unknown) => {
      if (isDevelopment) console.warn(`[${new Date().toLocaleTimeString()}] ${componentName}: ${message}`, data);
    },
    error: (message: string, data?: unknown) => {
      if (isDevelopment) {
        console.error(`[${new Date().toLocaleTimeString()}] ${componentName}: ${message}`, data);
      } else {
        window.Sentry?.captureMessage(message, {
          level: 'error',
          extra: {
            component: componentName,
            data,
          },
        });
      }
    },
    debug: (message: string, data?: unknown) => log(message, data),
  };
}
